import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CompareService {
  compare(
    a: number | string | undefined | null | string[] | unknown,
    b: number | string | undefined | null | string[] | unknown,
    isAsc: boolean
  ): number {
    const direction = isAsc ? 1 : -1;
    if (a && b) {
      return (a < b ? -1 : 1) * direction;
    }
    if (a && !b) {
      return isAsc ? -1 : 1;
    }
    if (!a && b) {
      return isAsc ? 1 : -1;
    }
    return 0;
  }
}
